import React from 'react';
import AnalyticsEvent from "./AnalyticsEvent";

/**
 * WhatsAppButton Component with built-in message types
 * 
 * @param {Object} props
 * @param {string} props.type - Message type: "header", "centreBased", "online", "primary5", or "level"
 * @param {string} props.level - Education level for "level" type (e.g., "primary 5")
 * @param {string} props.text - Custom message text (overrides type text if provided)
 * @param {string} props.source - Custom source (overrides type source if provided)
 * @param {string} props.action - Analytics action (default: "Click")
 * @param {string} props.label - Custom label (overrides type label if provided)
 * @param {string} props.phoneNumber - WhatsApp phone number (default: +6590625285)
 * @param {string} props.buttonText - Button display text (default: "Enquire Now")
 * @param {string} props.className - Additional CSS classes (default: "theme-btn-five")
 * @param {Object} props.htmlProps - Any additional HTML attributes to spread on the <a> element
 * @returns {JSX.Element}
 */
const WhatsAppEnquiryButton = ({
  type,
  level,
  text,
  source,
  action = "Click",
  label,
  phoneNumber = "+6590625285",
  buttonText = "Enquire Now",
  className = "theme-btn-five",
  children,
  ...htmlProps
}) => {
  // Set defaults based on type
  var messageText = ""

  switch (type) {
    case "header":
      messageText = messageText || "Hello! I would like to find out more about your tuition programme!";
      break;
      
    case "centreBasedLessons":
      messageText = messageText || "Hello! I would like to find out more about your centre based lessons!";
      break;
      
    case "onlineLessons":
      messageText = messageText || "Hello! I would like to find out more about your online lessons!";
      break;
    
    case "examPapers":
      if (level) {
        messageText = messageText || `Hello! I would like to find out more about your ${level} exam papers!`;
      }
      else{
        messageText = messageText || `Hello! I would like to find out more about your exam papers!`;
      }
      break;
    
    case "pricing":
      messageText = messageText || `Hello! I would like to find out more about your pricing!`;
      break;
      
    case "programmes":
      if (level) {
        messageText = messageText || `Hello! I would like to find out more about your ${level} curriculum!`;
      }
      else{
        messageText = messageText || `Hello! I would like to find out more about your curriculum!`;
      }
      break;
      
    default:
      // Fallback for unknown types
      messageText = messageText || "Hello! I would like to find out more!";
      break;
  }

  const handleClick = () => {
    AnalyticsEvent({
      category: "WhatsAppEnquire",
      action: action,
      source: source,
      label: label
    });
  };

  // Encode the text for the URL
  var encodedText = encodeURIComponent(messageText);
  if (text){
    encodedText = encodeURIComponent(text);
  }

  return (
    <a
      href={`https://wa.me/${phoneNumber}?lang=en&text=${encodedText}`}
      target="_blank"
      rel="noreferrer"
      className={className}
      onClick={handleClick}
      {...htmlProps}
    >
      <i className="fa fa-whatsapp"></i> {buttonText}
    </a>
  );
};

export default WhatsAppEnquiryButton;